import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Text } from 'components/ui';
import {
    colors, fontSizes, fontWeights, mediaQueries
} from 'style/config';

function PriceDisplay({ sku }) {
    return (
        <Box>
            {sku.salePrice ? (
                <Text css={styles.price}>
                    <Text
                        as='span'
                        color={colors.red}
                        css={styles.lineHeight}
                    >
                        {sku.salePrice}{' '}
                    </Text>
                    <Text
                        as='span'
                        css={[styles.lineHeight, styles.strikethrough]}
                    >
                        {sku.listPrice}
                    </Text>
                </Text>
            ) : (
                <Text css={styles.price}>{sku.listPrice}</Text>
            )}
        </Box>
    );
}

const styles = {
    price: {
        fontSize: `${fontSizes.base}px`,
        fontWeight: fontWeights.bold,
        lineHeight: '18px',
        [mediaQueries.xsMax]: {
            fontSize: `${fontSizes.sm}px`,
            lineHeight: '14px'
        }
    },
    lineHeight: {
        lineHeight: '18px',
        [mediaQueries.xsMax]: {
            lineHeight: '14px'
        }
    },
    strikethrough: {
        textDecoration: 'line-through'
    }
};

PriceDisplay.propTypes = {
    sku: PropTypes.shape({
        salePrice: PropTypes.string,
        listPrice: PropTypes.string
    }).isRequired
};

export default wrapFunctionalComponent(PriceDisplay, 'PriceDisplay');
